module.exports = __webpack_public_path__ + "img/camping-banner.b1d1e495.jpg";